export interface IColorChannels {
    r: number;
    g: number;
    b: number;
}

function parseHexToRgbChannels (hex: string): IColorChannels | null {
    let cleaned = hex.replace('#', '');

    if (cleaned.length === 3) {
        cleaned = cleaned.split('').map(c => c + c).join('');
    }

    if (cleaned.length !== 6) return null;

    return {
        r: parseInt(cleaned.slice(0, 2), 16),
        g: parseInt(cleaned.slice(2, 4), 16),
        b: parseInt(cleaned.slice(4, 6), 16),
    };
}

export function hexToRgb (hex: string): string | null {
    const channels = parseHexToRgbChannels(hex);
    if (!channels) return null;

    return `rgb(${channels.r}, ${channels.g}, ${channels.b})`;
}

export function hexToRgba (hex: string, alpha: number): string | null {
    const channels = parseHexToRgbChannels(hex);
    if (!channels) return null;

    return `rgba(${channels.r}, ${channels.g}, ${channels.b}, ${alpha})`;
}

export function hexToRgbChannels (hex: string): IColorChannels | null {
    const channels = parseHexToRgbChannels(hex);
    if (!channels) return null;
    return channels;
}

export function getRelativeLuminance (r: number, g: number, b: number): number {
    const [red, green, blue] = [r, g, b].map((channel) => {
        const normalized = channel / 255;
        return normalized <= 0.03928
            ? normalized / 12.92
            : ((normalized + 0.055) / 1.055) ** 2.4;
    });

    return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
}
